import { render, staticRenderFns } from "./SelectedInfoBar.vue?vue&type=template&id=01e5015d&scoped=true&"
import script from "./SelectedInfoBar.vue?vue&type=script&lang=js&"
export * from "./SelectedInfoBar.vue?vue&type=script&lang=js&"
import style0 from "./SelectedInfoBar.vue?vue&type=style&index=0&id=01e5015d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e5015d",
  null
  
)

export default component.exports